import { createApp } from 'vue'
import App from './App.vue'
import './style.css'
import { installConsoleErrorWarnShipping, shipLog } from './logging'
import { initStt } from './stt'

// Global error hooks -> Loki via /ifl (src/logging.ts, DESIGN.md; knol/data/llm-docs/logging.md).
// Installed before mount() so errors thrown during app startup are captured too. Mirrors what
// app-vue2 ships (src/ts/logShipper.ts + errorReporting.ts): console.error/warn are patched, and
// window.onerror / unhandledrejection are wired directly since neither passes through console.
installConsoleErrorWarnShipping()

window.addEventListener('error', (event) => {
  try {
    shipLog('error', 'uncaught:window', [event.error ?? event.message ?? 'window error'])
  } catch {
    // never let a logging hook break the kiosk
  }
})

window.addEventListener('unhandledrejection', (event) => {
  try {
    shipLog('error', 'uncaught:promise', [event.reason ?? 'unhandled rejection'])
  } catch {
    // never let a logging hook break the kiosk
  }
})

// Round-15: one app-wide kmb-stt WebSocket (voice commands + fingerprint corpus) — src/stt.ts.
initStt()

createApp(App).mount('#app')
